import React from 'react';
import Dashboard from './components/Dashboard';

const App: React.FC = () => {
  return <Dashboard />;
};

export default App;
